import { useContext } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import moment from 'moment';
import momentRuLocale from 'moment/locale/ru';
import { UploadContext } from '@yooink/youi/es/Upload/UploadContext';

import * as FilesApi from './Api/Files';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.compat.css';
import './Styles/Main.less';
import './Styles/Dashboard.less';
import 'react-datepicker/dist/react-datepicker.css';

import SystemRoute from './Pages/System/SystemRoute';
import MainPage from './Pages/Main';

import { UserContext } from './Components/UserContext';
import * as Theme from './Engine/Themes/pilgrim';
import { UsersRoute } from './Pages/Users/UsersRoute';
import { SitesRoute } from './Pages/Sites/SitesRoute';
import { SSOAuthRequestRoute } from './Pages/SSOAuthRequest/SSOAuthRequestRoute';

moment.updateLocale('ru', momentRuLocale);
moment.locale('ru');

export default function App () {
	const userCtx = useContext(UserContext);
	if (!userCtx.user) {
		return <Theme.AuthPage />;
	}
	return (
		<Router basename={window.__BASE_URL || '/'}>
			<UploadContext.Provider value={FilesApi}>
				<Theme.Layout>
					<Route exact path="/" component={MainPage} />
					<SystemRoute />
					<UsersRoute />
					<SitesRoute />
					<SSOAuthRequestRoute />
				</Theme.Layout>
			</UploadContext.Provider>

		</Router>
	);
}
